import React, { useCallback, Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Templates from './Templates';
import './Template.scss';
import { stringifyEqualityCheck } from './../../utils';
import * as actions from './Template.actions';
import * as selectors from './Template.selectors';
import * as loginActions from './../Login/Login.actions';
import * as loginSelectors from './../Login/Login.selectors';
import * as searchActions from './../Search/Search.actions';
import * as searchSelectors from './../Search/Search.selectors';
import Layout from './../Layout';
import { Helmet } from 'react-helmet';

const Template = (props) => {
    /* State to props */
    const departments = useSelector(selectors.getDepartments, stringifyEqualityCheck);
    const fetching = useSelector(selectors.getFetching);
    const search = useSelector(searchSelectors.getSearch);
    const searchType = useSelector(searchSelectors.getSearchType);
    const productType = useSelector(searchSelectors.getProductType);
    const user = useSelector(loginSelectors.getUser, stringifyEqualityCheck);
    const platformType = useSelector(loginSelectors.getPlatformType, stringifyEqualityCheck);

    /* Dispatch to props */
    const dispatch = useDispatch();
    const fetchDepartments = useCallback((id, subcategory) => dispatch(actions.fetchDepartments(id, subcategory)), [dispatch]);
    const setSearch = useCallback((value) => dispatch(searchActions.setSearch(value)), [dispatch]);
    const setSearchType = useCallback((value) => dispatch(searchActions.setSearchType(value)), [dispatch]);
    const setProductType = useCallback((value) => dispatch(searchActions.setProductType(value)), [dispatch]);
    const logout = useCallback((history) => dispatch(loginActions.logout(history)), [dispatch]);

    /* componentDidMount */
    useEffect(() => {
        if (parseInt(props.match.params.id) === 6) {
            setProductType(5);
        } else if (parseInt(props.match.params.id) === 9) {
            setProductType(1);
        } else if (parseInt(props.match.params.id) === 10) {
            setProductType(2);
        } else if (parseInt(props.match.params.id) === 11) {
            setProductType(3);
        } else if (parseInt(props.match.params.id) === 12) {
            setProductType(4);
        } else {
            setProductType(props.match.params.id);
        }
        
        fetchDepartments(props.match.params.id, props.match.params.subcategory);
    }, [fetchDepartments, setProductType, props.match.params.id, props.match.params.subcategory]);

    if (user == null) {
        logout(props.history);
        return null;
    }

    const handleFormRequest = () => {
        window.open('https://app.smartsheet.com/b/form/659061cdb259429981c282d3a58e50a2');
    };

    let title = '';
    let h3Message = <h3>Select a product to start your design.</h3>;
    if (parseInt(props.match.params.id) === 1) {
        title = 'Cards';
    } else if (parseInt(props.match.params.id) === 2) {
        title = 'Stationery Letterheads';
    } else if (parseInt(props.match.params.id) === 3) {
        title = 'Stationery Envelopes';
    } else if (parseInt(props.match.params.id) === 4) {
        title = 'Notecards';
    } else if (parseInt(props.match.params.id) === 5) {
        title = 'Forms';
        h3Message = (
            <div className="forms-header">
                <h4>Can't find the form you are looking for? Send a request to the Forms committee.</h4>
                <div className="button form-request-button" onClick={handleFormRequest}>Form Submission Request</div>
            </div>
        );
    } else if (parseInt(props.match.params.id) === 6) {
        title = 'COVID-19';
    } else if (parseInt(props.match.params.id) === 7) {
        title = 'Adult Apparel';
        if (departments.length > 0 && departments[0].breadcrumbs.length > 0) {
            title = departments[0].breadcrumbs[0].label;
        }
    } else if (parseInt(props.match.params.id) === 8) {
        title = 'Clearance';
    } else if (parseInt(props.match.params.id) === 16) {
        title = 'Marketing Collateral/Display Signage';
    } else if (parseInt(props.match.params.id) === 17) {
        title = 'Pocket Folders';
    }

    return (
        <Layout
            title={<Fragment><i className="fas fa-id-card" /> Select Product</Fragment>}
            step={2}
            history={props.history}
        >
            <Helmet>
                <title>Products - UT Physicians</title>
            </Helmet>
            <div className="template-container">
                <h2>{title}</h2>
                {h3Message}
                <Templates
                    departments={departments}
                    fetching={fetching}
                    search={search}
                    searchType={searchType}
                    user={user}
                    platformType={platformType}
                    productType={productType}
                    productId={props.match.params.id}
                    subcategory={props.match.params.subcategory}
                    history={props.history}
                    setSearch={setSearch}
                    setSearchType={setSearchType}
                    setProductType={setProductType}
                />
            </div>
        </Layout>
    );
};

Template.propTypes = {

};

export default Template;
